import { PlannerEcsMultiSystem, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import PlatsaSoftClosingHingeComponent, { PlatsaSoftClosingHingeComponentSerializer } from '../components/PlatsaSoftClosingHingeComponent';
export class PlatsaSoftClosingHingeSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'PlatsaSoftClosingHingeSystem', [
            PlatsaSoftClosingHingeComponent.id,
            ComponentIds.IN_SCENE_COMPONENT_ID
        ]);
        this.doorProducts = [];
        const componentDeserializerRegistry = this.coreApi.getServices().componentDeserializerRegistry;
        componentDeserializerRegistry.register(new PlatsaSoftClosingHingeComponentSerializer());
    }
    setMarketProducts(marketProducts) {
        this.doorProducts = marketProducts.filter(p => [ProductType.PLATSA_HINGE_DOOR_ASM, ProductType.PLATSA_SC_HINGE_DOOR_ASM].includes(p.type));
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === PlatsaSoftClosingHingeComponent.id) {
            this.replaceHingesOnDoorsInScene();
        }
        else if (newComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID &&
            this.coreApi.entities.isProductType(entity, ProductType.PLATSA_HINGE_DOOR_ASM) &&
            this.softClosingSelected()) {
            this.replaceHingesOnDoor(entity);
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === PlatsaSoftClosingHingeComponent.id) {
            this.replaceHingesOnDoorsInScene();
        }
    }
    replaceHingesOnDoorsInScene() {
        const doorsInScene = this.coreApi.entities.getByComponent(ComponentIds.DOOR_COMPONENT_ID);
        doorsInScene.forEach(door => {
            this.replaceHingesOnDoor(door);
        });
    }
    replaceHingesOnDoor(door) {
        const expectedDoorProductType = this.softClosingSelected()
            ? ProductType.PLATSA_SC_HINGE_DOOR_ASM
            : ProductType.PLATSA_HINGE_DOOR_ASM;
        const doorInfo = door.getComponent(ProductInfoComponent.id);
        const doorSize = this.coreApi.entities.getEntityComSize(door);
        if (doorInfo?.productType !== expectedDoorProductType) {
            const replacementDoor = this.doorProducts.find(p => p.communicatedDimensions.width === doorSize?.width &&
                p.communicatedDimensions.height === doorSize?.height &&
                p.name === doorInfo?.productName &&
                p.design === doorInfo?.design &&
                p.type === expectedDoorProductType);
            if (replacementDoor) {
                this.coreApi.products.replace(door.id, replacementDoor.coreProductId);
            }
        }
    }
    softClosingSelected() {
        return (this.coreApi.entities.getScene()?.hasComponent(PlatsaSoftClosingHingeComponent.id) || false);
    }
}
//# sourceMappingURL=PlatsaSoftClosingHingeSystem.js.map